/* eslint-disable no-template-curly-in-string */
import { component } from "picoapp";
import { type Context, type SelectedVariant } from "../../state";

export const productIntro = component<Context>((node, context) => {
  const isProductBundle = node.dataset.productBundle === "true";
  const isShopifyBundle = node.dataset.shopifyBundle === "true";

  if (isProductBundle || isShopifyBundle) {
    return;
  }

  const updateVariantSalesBadge = (selectedVariant: SelectedVariant) => {
    const salesBadge = node.querySelector<HTMLElement>("#sales-badge");
    if (!salesBadge) return;

    const badgeNode = salesBadge.querySelector<HTMLSpanElement>(
      "[data-tbsp-component='badge']"
    );
    if (!badgeNode) return;

    const salesBadgeText = selectedVariant?.badgeSale;
    if (salesBadgeText) {
      badgeNode.innerHTML = salesBadgeText;
      badgeNode.classList.remove("hidden");
    } else {
      badgeNode.innerHTML = "";
      badgeNode.classList.add("hidden");
    }
  };

  context.on("tbsp:variant-selected", ({ selectedVariant }) => {
    updateVariantSalesBadge(selectedVariant);
  });
});
